const s = {
  name: "Equalizer",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24.1,4c0.5-2.3,2.5-4,4.9-4c2.4,0,4.4,1.7,4.9,4H40v2h-6.1c-0.5,2.3-2.5,4-4.9,4c-2.4,0-4.4-1.7-4.9-4H0V4
			H24.1z M29,2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.7,0,3-1.3,3-3S30.7,2,29,2z"/>
		<path class="st0" d="M24.1,34c0.5-2.3,2.5-4,4.9-4c2.4,0,4.4,1.7,4.9,4H40v2h-6.1c-0.5,2.3-2.5,4-4.9,4c-2.4,0-4.4-1.7-4.9-4H0v-2
			H24.1z M29,32c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.7,0,3-1.3,3-3S30.7,32,29,32z"/>
		<path class="st0" d="M6.1,21H0v-2h6.1c0.5-2.3,2.5-4,4.9-4c2.4,0,4.4,1.7,4.9,4H40v2H15.9c-0.5,2.3-2.5,4-4.9,4
			C8.6,25,6.6,23.3,6.1,21z M8,20c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3s-1.3-3-3-3C9.3,17,8,18.3,8,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Equalizer
};
